import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import spoe from "./config/spoe";
import gruene from "./config/gruene";
import oevp from "./config/oevp";
import fpoe from "./config/fpoe";
import neos from "./config/neos";
import thc from "./config/thc";
import bier from "./config/bier";
import links from "./config/links";

export const store = new Vuex.Store({
  state: {
    currentParty: 'SPÖ',
    currentVersion: 'spoe/spoe_1.jpg',
    showDisclaimer: true,
    parties: [
      spoe,
      gruene,
      oevp,
      fpoe,
      neos,
      thc,
      bier,
      links
    ],
    lines: []
  },
  mutations: {
    setRemoteState(state, newState) {
      state.currentParty = newState.currentParty;
      state.currentVersion = newState.currentVersion;
      state.lines = newState.lines;
    },
    setDefaultLines(state) {
      state.lines = state.parties.find(party => party.name == state.currentParty).linesDefault;
    },
    setLines(state, lines) {
      state.lines = lines;
    },
    setParty(state, party) {
      // mutate state
      state.currentParty = party;
    },
    setVersion(state, version) {
      // mutate state
      state.currentVersion = version;
    },
    removeParty(state, index) {
      state.lines.splice(index, 1);
    },
    setDefaultVersion(state) {
      state.currentVersion = state.parties.find(party => party.name == state.currentParty).versions[0];
    },
  },
  getters: {
    // returns all custom styles for current party
    getCustomStyles: (state) => {
      return state.parties.find(party => party.name == state.currentParty).customStyles;
    },
    // returns custom style of current party for type (index of custom style)
    getCustomStyle: (state, getters) => (type) => {
      return getters.getCustomStyles[type].style;
    },
    // returns base style of current party
    getBaseStyle: (state) => {
      return state.parties.find(party => party.name == state.currentParty).baseStyle;
    },
    // returns true if current parties blocks are rotated
    isRotated: (state) => {
      return (state.parties.find(party => party.name == state.currentParty).isRotated == true);
    },
    // returns all Versions of the political campaign for the current party
    getVersions: (state) => {
      return state.parties.find(party => party.name == state.currentParty).versions;
    },
    getContainerStyle: (state) => {
      var containerStyle = state.parties.find(party => party.name == state.currentParty).containerStyle;
      console.log(containerStyle);
      if (containerStyle == undefined) {
        return {};
      }
      return containerStyle;
    },
    getCustomContainerStyles: (state) => {
      return state.parties.find(party => party.name == state.currentParty) && state.parties.find(party => party.name == state.currentParty).customContainerStyles ? state.parties.find(party => party.name == state.currentParty).customContainerStyles : null;
    },
    getCustomContainerVersionStyle: (state, getters)  => {
      return getters.getCustomContainerStyles != null && getters.getCustomContainerStyles.find(style => style.name == state.currentVersion) ? getters.getCustomContainerStyles.find(style => style.name == state.currentVersion).style : {};
    },
  }
});



// WEBPACK FOOTER //
// ./src/store.js